"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
exports.__esModule = true;
exports.tagPropType = exports.productPropType = exports.pricePropType = exports.menuModuleType = exports.logoVariantsType = exports.linkPropType = exports.imagePropType = exports.flyoutMenuPropType = exports.dataPropType = exports.ctaPropType = void 0;
var _propTypes = _interopRequireDefault(require("prop-types"));
var _text = require("@mmc/text");
var imagePropType = exports.imagePropType = _propTypes["default"].shape({
  image: _propTypes["default"].string,
  altText: _propTypes["default"].string
});
var linkPropType = exports.linkPropType = _propTypes["default"].shape({
  url: _propTypes["default"].string,
  label: _propTypes["default"].string,
  order: _propTypes["default"].number
});
var pricePropType = exports.pricePropType = _propTypes["default"].shape({
  label: _propTypes["default"].string,
  value: _propTypes["default"].number,
  displayValue: _propTypes["default"].string
});
var ctaPropType = exports.ctaPropType = _propTypes["default"].shape({
  description: _propTypes["default"].string,
  order: _propTypes["default"].number,
  vehicleTag: _propTypes["default"].string,
  placement: _propTypes["default"].string,
  parentItem: _propTypes["default"].string,
  openNewTab: _propTypes["default"].bool
});
var tagPropType = exports.tagPropType = _propTypes["default"].shape({
  label: _propTypes["default"].string
});
var menuModuleType = exports.menuModuleType = _propTypes["default"].shape({
  open: _propTypes["default"].string,
  closed: _propTypes["default"].string
});
var logoVariantsType = exports.logoVariantsType = _propTypes["default"].shape({
  expandedImage: imagePropType,
  collapsedImage: imagePropType,
  altText: _propTypes["default"].string,
  link: linkPropType
});
var productPropType = exports.productPropType = _propTypes["default"].shape({
  id: _propTypes["default"].string,
  code: _propTypes["default"].string,
  description: _propTypes["default"].string,
  price: pricePropType,
  vehicleImage: imagePropType,
  vehicleBackgroundImage: imagePropType,
  name: _propTypes["default"].string,
  specifications: _propTypes["default"].any,
  cta: ctaPropType,
  tag: tagPropType
});
var flyoutMenuPropType = exports.flyoutMenuPropType = _propTypes["default"].shape({
  name: _propTypes["default"].string,
  products: _propTypes["default"].arrayOf(productPropType),
  links: _propTypes["default"].arrayOf(linkPropType),
  backgroundImage: imagePropType,
  addPriceDisclaimer: _propTypes["default"].bool,
  disclaimerId: _propTypes["default"].string,
  disclaimerData: _text.disclaimerDataPropTypes
});
var dataPropType = exports.dataPropType = _propTypes["default"].shape({
  menuModule: menuModuleType,
  showQuickLinks: _propTypes["default"].bool,
  logo: logoVariantsType,
  sectionLinks: _propTypes["default"].arrayOf(linkPropType),
  kbaLinks: _propTypes["default"].arrayOf(linkPropType),
  flyoutMenu: _propTypes["default"].arrayOf(flyoutMenuPropType)
});